<div class="partners-logo" [class.arebic-content]="textDirection == 'rtl'">
    <div class="partners-slide">
        <h1 translate>LEARN_MORE_PAGE.TRUST_BY</h1>
        <div class="card">
            <div class="desktop-grid">
                <p-carousel [value]="partnersItems" [numVisible]="6"  [showNavigators]="true" [numScroll]="6"  [responsiveOptions]="responsiveOptions"  >
                    <ng-template let-item pTemplate="partnersItems">
                        <img src="{{item.imgUrl}}" alt="Logo Partners" class="partners-icon">
                    </ng-template>
                </p-carousel>
            </div>
        </div>
    </div>